import './StudioPage.scss'
import { useWindowSize } from '@uidotdev/usehooks'
import type { ReactNode } from 'react'
import { StructuredText } from 'react-datocms'
import { DatoImage } from '#src/components/image/DatoImage.js'
import { LocalizedLink } from '#src/components/LocalizedLink.js'
import type { StudioData } from '#src/data/data.js'
import { useIsChildRoute } from '#src/hooks/useIsChildRoute.js'
import { ServicesIntro } from '#src/pages/services/ServicesIntro.js'

interface Props {
  data: StudioData
  children?: ReactNode
}

export function StudioPage(props: Props): ReactNode {
  const windowSize = useWindowSize()
  const popupIsOpen = useIsChildRoute('/services/studio-rental')
  const innerWidth = windowSize.width || 0
  const isMobile = innerWidth <= 647
  // todo: use responsive image, srcSet that sets different image

  return (
    <>
      <ServicesIntro
        aria-hidden={popupIsOpen}
        description={props.data.heading}
        image={
          innerWidth > 831
            ? props.data.heroImageDesktop.responsiveImage
            : props.data.heroImageMobile.responsiveImage
        }
      />

      <section className="rental__description">
        <div className="rental__description_column rental__description_column_1">
          <StructuredText data={props.data.descriptionColumn1} />
        </div>

        <div className="rental__description_column rental__description_column_2">
          <StructuredText data={props.data.descriptionColumn2} />

          {/* <form className="rental__pricelist-form">*/}
          {/*  <input className="rental__email-input" type="email" id="email" placeholder="e-mail" />*/}
          {/*  <button className="rental__submit-btn" type="submit">*/}
          {/*    get the pricelist*/}
          {/*  </button>*/}
          {/* </form>*/}
        </div>
      </section>

      <section className="rental__studios">
        <div className="rental__studios_text">
          <p className="rental__studios-subtitle">{props.data.subtitle}</p>
          <p className="rental__studios-undertext">{props.data.undertext}</p>
        </div>
        <div className="rental__studios-container">
          {props.data.galleries.map(gallery => (
            <LocalizedLink
              href={`/services/studio-rental/${gallery.slug}`}
              scroll={false}
              key={gallery.slug}
            >
              <div className="rental__studio">
                <DatoImage
                  className="rental__studio-image"
                  data={gallery.cover.responsiveImage}
                  containerSize={isMobile ? 100 : 30}
                  style={{ maxWidth: '100%' }}
                />
                <h3 className="rental__studio-title">{gallery.title}</h3>
              </div>
            </LocalizedLink>
          ))}
        </div>
      </section>

      {props.children}
    </>
  )
}
